<div class="navbar no-radius">
  <a
    class="navbar-brand"
    href="/">
    <img
      class="left-menu-logo"
      [src]="'/assets/img/channels/favicon.png'"
      alt=".">
    <div *ngIf="isChannelsClientType()">
      <img
        class="left-menu-brand"
        [src]="'/assets/img/channels/channels-logo.svg'"
        *ngIf="this.isChannelsClientType()"
        alt="channels">
    </div>
    <div *ngIf="isShoperConnectClientType()">
      <img
        class="left-menu-brand"
        [src]="'/assets/img/shoper-connect/shoper-logo.svg'"
        alt="shoper-connect">
    </div>
  </a>
</div>
<div
  flex
  class="hide-scroll">
  <div
    class="scroll nav-light p-b-lg">
    <ul class="nav">

      <ng-container>
        <li [class.active]="isRouteActive('/dashboard')">
          <a [routerLink]="['/dashboard']">
              <span class="nav-icon">
                  <i class="material-icons">dashboard</i>
              </span><span
            class="nav-text"
            translate>MENU.DASHBOARD</span></a>
        </li>

        <li
          [class.active]="isRouteActive('/call-history') || isRouteActive('/call-details')"
          *ngxPermissionsOnly="'MANAGE_RECORDS_PERMISSION'">
          <a [routerLink]="['/call-history']">
              <span class="nav-icon history">
                <i class="fas fa-history"></i>
              </span>
            <span
              class="nav-text"
              translate>CALL_HISTORY.TITLE</span></a>
        </li>

        <li
          [class.active]="isRouteActive('/address-book') || isRouteActive('/contact-details')"
          *ngxPermissionsOnly="'MANAGE_RECORDS_PERMISSION'">
          <a [routerLink]="['/address-book']">
              <span class="nav-icon address-book">
                <i class="fas fa-address-book"></i>
              </span>
            <span
              class="nav-text"
              translate>ADDRESS_BOOK.TITLE</span></a>
        </li>

        <li
          [class.active]="isRouteActive('/contacts') || isRouteActive('/event-details')"
          *ngxPermissionsOnly="'MANAGE_RECORDS_PERMISSION'">
          <a [routerLink]="['/contacts']">
              <span class="nav-icon address-book">
                  <i class="material-icons">event_note</i>
              </span>
            <span
              class="nav-text"
              translate>RECORDS_LIST.TITLE</span></a>
        </li>

        <li
          [class.active]="isRouteActive('/users')"
          *ngxPermissionsOnly="'EDIT_USER_PERMISSION'">
          <a [routerLink]="['/users/active/0/details']">
            <span class="nav-icon">
                <i class="material-icons">person</i>
              </span>
            <span
              class="nav-text"
              translate
            >MENU.USERS</span>
          </a>
          <ul class="nav-sub">
            <li [class.active]="isRouteActive('/users/all')">
              <a [routerLink]="['/users/all/0/details']">
                  <span
                    class="nav-text"
                    translate>ALL</span>
              </a>
            </li>
            <li [class.active]="isRouteActive('/users/active')">
              <a [routerLink]="['/users/active/0/details']">
                  <span
                    class="nav-text"
                    translate>ACTIVE</span>
              </a>
            </li>
            <li [class.active]="isRouteActive('/users/inactive')">
              <a [routerLink]="['/users/inactive/0/details']">
                  <span
                    class="nav-text"
                    translate>INACTIVE</span>
              </a>
            </li>
            <li [class.active]="isRouteActive('/users/pending')">
              <a [routerLink]="['/users/pending/0/invite']">
                  <span
                    class="nav-text"
                    translate>PENDING</span>
              </a>
            </li>
          </ul>
        </li>

        <li
          [class.active]="isRouteActive('/ivr') || isRouteActive('/phone-numbers')"
          *ngxPermissionsOnly="'EDIT_USER_PERMISSION'">
          <a [routerLink]="['/phone-numbers']">
            <span class="nav-icon"><i class="fas fa-cog"></i></span>
            <span class="nav-text">{{ 'MENU.SETTINGS' | translate }}</span>
          </a>
          <ul class="nav-sub">
            <li
              [class.active]="isRouteActive('/ivr')"
              *ngxPermissionsOnly="'MANAGE_IVR_PERMISSION'">
              <a
                [routerLink]="['/ivr']">
                <span class="nav-text">{{ 'IVR.LABEL' | translate }}</span>
              </a>
            </li>
            <li
              [class.active]="isRouteActive('/phone-numbers')"
              *ngxPermissionsOnly="'CHANGE_ACCOUNT_SETTINGS_PERMISSION'">
              <a [routerLink]="['/phone-numbers']">
              <span
                class="nav-text"
                translate>NUMBERS.INBOUND_SETTINGS</span></a>
            </li>
          </ul>
        </li>

        <li [class.link]="isSmsLink() || isWebCallLink()" [class.active]="isRouteActive('/integrations')"
            *ngxPermissionsOnly="'INTEGRATION_PERMISSION'">
          <a [routerLink]="['/integrations']">
              <span class="nav-icon">
                  <i class="material-icons">add_box</i>
              </span><span
            class="nav-text"
            translate>MENU.INTEGRATIONS</span></a>
          <ul class="nav-sub">
            <li
              [class.active]="isRouteActive('/integrations/list')"
              *ngxPermissionsOnly="'INTEGRATION_PERMISSION'">
              <a
                [routerLink]="['/integrations/list']">
                <span class="nav-text">{{ 'INTEGRATIONS.MARKETPLACE' | translate }}</span>
              </a>
            </li>
            <li
              [class.active]="isRouteActive('/integrations/imports/list')"
              *ngxPermissionsOnly="'INTEGRATION_PERMISSION'">
              <a
                [routerLink]="['/integrations/imports/list']">
                <span class="nav-text">{{ 'INTEGRATIONS.IMPORTS' | translate }}</span>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-header hidden-folded ch-label-group">
          <small
            class="text-muted"
          >{{'MENU.CALLING_MODES' | translate}}
          </small>
        </li>

        <li [class.active]="isRouteActive('/mobile-app')">
          <a [routerLink]="['/mobile-app']">
              <span class="nav-icon">
                  <span class="material-icons">phone_iphone</span>
              </span>
            <span class="nav-text display-inline" translate>MENU.MOBILE_APP</span>
          </a>
        </li>

        <li [class.active]="isRouteActive('/extension')">
          <a (click)="onGetWidget()" [routerLink]="['/extension']">
              <span class="nav-icon">
                  <i class="material-icons">widgets</i>
              </span><span
            class="nav-text"
            translate>MENU.WIDGET</span></a>
        </li>
        <li [class.active]="isRouteActive('/integrations/two_way')" *ngIf="smsEnabled">
          <a [routerLink]="['integrations', 'two_way']"
             class="nav-link">
              <span class="nav-icon">
                  <i class="material-icons">chat_bubble</i>
              </span><span
            class="nav-text"
            translate>MENU.SMS</span>
<!--            <span class="new-feature">New</span>-->
          </a>
        </li>
        <!--        <li [class.active]="isRouteActive('/integrations/web_call')">-->
        <!--          <a [routerLink]="['/integrations/web_call']"-->
        <!--             class="nav-link">-->
        <!--              <span class="nav-icon">-->
        <!--                  <i class="material-icons">call</i>-->
        <!--              </span><span-->
        <!--            class="nav-text"-->
        <!--            translate>MENU.WEB_CALL</span>-->
        <!--            <span class="new-feature">New</span>-->
        <!--          </a>-->
        <!--        </li>-->
        <li [class.active]="isRouteActive('/lead-generation')"
            *ngxPermissionsOnly="'INTEGRATION_PERMISSION'">
          <a [routerLink]="['lead-generation']"
             class="nav-link">
              <span class="nav-icon">
                  <i class="material-icons">call</i>
              </span><span
            class="nav-text"
            translate>MENU.WEB_CALL</span>
<!--            <span class="new-feature">New</span>-->
          </a>
        </li>
      </ng-container>

    </ul>
  </div>
</div>

